// Centralized site configuration — edit this file to update logos, contact info, etc.

export const SITE = {
  name: "Jain Interior Solutions",
  tagline: "Intelligent Living. Premium Interiors. Pan-India Distribution.",
  email: "info@jaininteriorsolutions.in",
  // Primary contact (used in navbar / fallbacks). Defaults to Fibaro line.
  phone: "+91 73050 57336",
  whatsapp: "917305057336",
  // Dedicated lines per vertical
  contacts: {
    fibaro: {
      label: "Fibaro & Home Automation",
      phone: "+91 73050 57336",
      whatsapp: "917305057336",
    },
    interior: {
      label: "Premium Interior Products",
      phone: "+91 63850 57336",
      whatsapp: "916385057336",
    },
  },
  address: {
    line1: "984A, First Floor",
    line2: "Mettupalayam Road",
    city: "Coimbatore – 641002",
    state: "Tamil Nadu",
    country: "India",
  },
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    youtube: "#",
  },
  map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.123!2d76.9558!3d11.0168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sCoimbatore!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const NAV = [
  { label: "About Us", path: "/about" },
  { label: "Fibaro India", path: "/fibaro" },
  { label: "Solutions", path: "/solutions" },
  { label: "Dealer Network", path: "/dealers" },
  { label: "Premium Interior", path: "/interior" },
  { label: "Support", path: "/support" },
  { label: "Contact", path: "/contact" },
];

// Full nav (used in footer / mobile menu)
export const NAV_FULL = [
  { label: "Home", path: "/" },
  ...[
    { label: "About Us", path: "/about" },
    { label: "Fibaro India", path: "/fibaro" },
    { label: "Solutions", path: "/solutions" },
    { label: "Dealer Network", path: "/dealers" },
    { label: "Premium Interior", path: "/interior" },
    { label: "Support", path: "/support" },
    { label: "Contact", path: "/contact" },
  ],
];

// Premium imagery from Unsplash / Pexels
export const IMG = {
  jis: "/brands/jis-logo-transparent.png",
  fibaroLogo: "/brands/fibaro-logo-transparent.png",
  hero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2400&q=85",
  heroAlt: "https://images.pexels.com/photos/16573669/pexels-photo-16573669.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2400",
  villa: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1800&q=85",
  livingRoom: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1800&q=85",
  smartPanel: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1800&q=85",
  thermostat: "https://images.unsplash.com/photo-1545259742-b4fd8fea67e4?auto=format&fit=crop&w=1600&q=85",
  hardware: "https://images.pexels.com/photos/38235554/pexels-photo-38235554.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  doorHandle: "https://images.unsplash.com/photo-1702573849436-da16072e7fd3?auto=format&fit=crop&w=1600&q=85",
  kitchen: "https://images.unsplash.com/photo-1556909114-44e3e9699e2b?auto=format&fit=crop&w=1800&q=85",
  bedroom: "https://images.unsplash.com/photo-1616137422495-1e9e46e2aa77?auto=format&fit=crop&w=1800&q=85",
  hotel: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1800&q=85",
  office: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1800&q=85",
  apartment: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1800&q=85",
  retrofit: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1800&q=85",
  interior: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1800&q=85",
  bath: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1600&q=85",
  laminate: "https://images.unsplash.com/photo-1615875221489-4c4dc12dc6d4?auto=format&fit=crop&w=1600&q=85",
  louver: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85",
  panel: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=85",
  lock: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=85",
  digitalLock: "https://images.unsplash.com/photo-1581092335203-be4d62f7bd07?auto=format&fit=crop&w=1600&q=85",
  curtain: "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1600&q=85",
  light: "https://images.unsplash.com/photo-1565183997392-2f6f122e5912?auto=format&fit=crop&w=1600&q=85",
  showcase: "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=2000&q=85",
  ctaBg: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=2400&q=85",
  about: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=2000&q=85",
};

// Brands We Represent — { name, logo } pairs. Logo files live in /public/brands/.
// To add more: drop the logo into /app/frontend/public/brands/ and add an entry here.
export const BRANDS = [
  { name: "Fibaro", logo: "/brands/fibaro-logo-transparent.png" },
  { name: "Hablo", logo: "/brands/hablo.png" },
  { name: "Europa", logo: "/brands/europa-transparent.png" },
  { name: "Yale", logo: "/brands/yale.jpg" },
  { name: "Ebco", logo: "/brands/ebco-transparent.png" },
  { name: "Hafele", logo: "/brands/hafele-transparent.png" },
  { name: "Hettich", logo: "/brands/hettich-transparent.png" },
  { name: "Woods & Finesse", logo: "/brands/woods-finesse-transparent.png" },
];
